export const IMAGES_PATH = `${process.env.REACT_APP_IMAGES_URL}`;